export default () => {
    const checkBox = document.getElementById('BeekeeperRegisterForm_RegisterForm_RegisteredNZBeekeeper')
        ? document.getElementById('BeekeeperRegisterForm_RegisterForm_RegisteredNZBeekeeper')
        : document.getElementById('CompanyInformationForm_CompanyInformationForm_RegisteredNZBeekeeper');

    const accBox = document.querySelector('.credit-acc');
    const accClose = document.querySelector('.credit-acc__close');
    const accBg = document.querySelector('.credit-acc__bg');

    if (checkBox && accBox) {
        checkBox.addEventListener('change',() => {
            if(checkBox.checked){
                accBox.classList.add('active');
            }
            else{
                accBox.classList.remove('active');
            }
        });

        accClose.addEventListener('click', (e) => {
            e.preventDefault();
            accBox.classList.remove('active');
            return false;
        })

        accBg.addEventListener('click', () => {
            accBox.classList.remove('active');
        });
    }
}
